export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10619.c5c0a9c8.jpg";